import { useQuery } from 'react-query';

import { customerGet as queryFn } from 'api/endPoints/customerGet';

export const useQueryCustomerGet = (params: { customerId: number | undefined }) => {
    return useQuery(['customerGet', params], () => queryFn(params), {});
};
